"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventVideoExternalStatus = void 0;
var EventVideoExternalStatus;
(function (EventVideoExternalStatus) {
    EventVideoExternalStatus["InQueue"] = "queue";
    EventVideoExternalStatus["Uploading"] = "uploading";
    EventVideoExternalStatus["Downloading"] = "downloading";
    EventVideoExternalStatus["Uploaded"] = "uploaded";
    EventVideoExternalStatus["Downloaded"] = "downloaded";
    EventVideoExternalStatus["LowQuality"] = "low_quality";
    EventVideoExternalStatus["Error"] = "error";
})(EventVideoExternalStatus = exports.EventVideoExternalStatus || (exports.EventVideoExternalStatus = {}));
//# sourceMappingURL=event-video-external-status.js.map